import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { getTimestampFromDuration } from "../utils/timestampUtils";
import ShareIcon from '@mui/icons-material/Share';
import SaveIcon from '@mui/icons-material/Save';
import IosShareIcon from '@mui/icons-material/IosShare';
import { useTheme } from "@emotion/react";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ShareDialog from "../style/ShareDialog";
import { URL_LENGTH_LIMIT } from "./VideoComponent";

const ControlButtons = ({
        showShareUrl,
        loop,
        loopButtonClick,
        handleBookmarkEvent,
        handleUnloopEvent,
        handleExportBookmarks,
        handleOpenExportDialog,
        handleShareButtonClick,
        setOpenQuickMarksDialog,
        shareLink,
    }) => {
    const theme = useTheme();
    const [openShareDialog, setOpenShareDialog] = useState(false);

    return (
        <>
        <Grid container 
        justifyContent="space-between"
        alignItems="center"
        width="100%">
            <Grid item >
                <Grid container spacing={2}>
                <Grid item>
                    <Tooltip title="Break your video into sections to take notes or to loop through a section again." size="md" arrow>
                    <Button 
                        variant="contained" 
                        onClick={(e) => handleBookmarkEvent(e)}
                        sx={{ paddingTop: "10px" }}
                        style={{textTransform: 'capitalize'}}
                    > Mark
                    </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Quickly load in a series of marks by providing a list of time stamps." size="md" arrow>
                    <Button 
                        variant="contained" 
                        onClick={(e) => {setOpenQuickMarksDialog(true)}}
                        sx={{ paddingTop: "10px" }}
                        style={{
                        textTransform: 'capitalize',
                        backgroundColor: theme.palette.gray.main,
                        }}
                    > Quick Marks
                    </Button>
                    </Tooltip>
                </Grid>
                {loopButtonClick && (
                    <Grid item>
                    <Tooltip title="Unloop from the section" size="md" arrow>
                    <Button 
                        variant="contained" 
                        onClick={(e) => handleUnloopEvent(e)}
                        style={{
                        backgroundColor: theme.palette.secondary.main,
                        height: "100%",
                        textTransform: 'capitalize'
                        }}
                        sx={{ paddingTop: "10px" }}
                    >
                        Unloop: {getTimestampFromDuration(loop[0])} <ArrowRightAltIcon size={10}/> {getTimestampFromDuration(loop[1])}
                    </Button>
                    </Tooltip>
                    </Grid>)}
            </Grid>
            </Grid>
            <Grid item >
            <Grid container spacing={1}>
                <Grid item>
                <Tooltip title="Save the bookmarks in ClipThoughts' json file" size="md" arrow>
                <IconButton 
                    variant="contained" 
                    onClick={(e) => handleExportBookmarks()}
                    sx={{ paddingTop: "10px" }}
                >
                    <SaveIcon />
                </IconButton>
                </Tooltip>
                </Grid>
                <Grid item>
                <Tooltip title="Export the bookmarks" size="md" arrow>
                    <IconButton 
                    variant="contained" 
                    onClick={(e) => handleOpenExportDialog()}
                    sx={{ paddingTop: "10px" }}
                    >
                        <IosShareIcon />
                    </IconButton>
                </Tooltip>
                </Grid>
                {showShareUrl && <Grid item>
                <Tooltip title="Share URL" size="md" arrow>
                    <IconButton 
                    variant="contained" 
                    onClick={(e) => {handleShareButtonClick();setOpenShareDialog(true)}}
                    sx={{ paddingTop: "10px" }}
                    >
                        <ShareIcon />
                    </IconButton>
                </Tooltip>
                </Grid>}
                </Grid>
            </Grid>
            <ShareDialog
                openShareDialog={openShareDialog} 
                setOpenShareDialog={setOpenShareDialog}
                shareLink={shareLink}
            />
        </Grid>
        </>
    );
}

export default ControlButtons;